
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"15-a","cx":"46.588%","cy":"65.195%","r":"100%","fx":"46.588%","fy":"65.195%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFD404"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#FFA204"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"24.5","fill":"#FFF","stroke":"#FFF","stroke-width":"3"}}),_c('circle',{attrs:{"cx":"32","cy":"32","r":"23","fill":"url(#15-a)"}}),_c('circle',{attrs:{"cx":"42","cy":"31","r":"8","fill":"#FFF"}}),_c('circle',{attrs:{"cx":"41.5","cy":"27.5","r":"3.5","fill":"#353741"}}),_c('circle',{attrs:{"cx":"23","cy":"31","r":"8","fill":"#FFF"}}),_c('circle',{attrs:{"cx":"21.5","cy":"27.5","r":"3.5","fill":"#353741"}}),_c('rect',{attrs:{"width":"14","height":"4","x":"25","y":"44","fill":"#353741","rx":"2"}})])])
          )
        }
      }
    